var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview"},[_c('div',{ref:"container",staticClass:"container"}),(_vm.readyScene)?_c('billboard',{ref:"billboard"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }